import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import { formatName } from "../../../../utils/utils";
import HotScore from "../cols/HotScore";

const styles = () => ({
  root: {
    marginTop: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  text: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
});

const CorporationNameAndKeymanName = ({ classes, item, disabled, hotScore }) => {
  return (
    <div className={classes.root}>
      {hotScore !== null && hotScore !== undefined && <HotScore score={hotScore} />}
      <Typography
        variant="subheading"
        className={classes.text}
        style={{
          fontWeight: "bold",
          color: disabled ? "#B1B3B9" : "#181819",
        }}
      >
        {formatName(item)}
      </Typography>
    </div>
  );
};

CorporationNameAndKeymanName.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  hotScore: PropTypes.number,
};

export default withStyles(styles)(CorporationNameAndKeymanName);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/CorporationNameAndKeymanName.jsx